import EventBus from '@/components/mixins/event-bus-mixin'
export default {
  name: 'playerPreviewPopUp',
  inject: [
    '$utils'
  ],
  components: {
  },
  props: {
    isVisibleProp: {
      type: Boolean,
      default () { return false }
    }
  },
  watch: {
    isVisibleProp (newisVisible) {
      this.isVisible = newisVisible
    }
  },
  mixins: [],
  data () {
    return {
      isVisible: this.isVisibleProp,
      onCloseCallback: null,
      previewOrientation: null,
      preview: null,
      videoPlayer: null,
      led: false
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('player-preview-popup-change', { action, payload: { data } })
      }
    },
    handleCloseIconClick (domEvent) {
      this.onCloseCallback = null
      this.isVisible = false
      this.preview = null
      this.previewOrientation = null
    },
    setVideoPreview () {
      this.videoPlayer = this.$refs.playerPreviewPopUpVideoPreview

      this.videoPlayer.addEventListener('loadeddata', () => { this.videoPlayer.play() })
      this.videoPlayer.addEventListener('play', () => {})
      this.videoPlayer.addEventListener('ended', () => {})
    },
    filterPreview (previewSrc) {
      const preview = this.$utils.clone(previewSrc)
      if (!preview._edit) preview._edit = {}

      // For Ajax iframes
      preview._edit.uid = this.$utils.generateUniqueID()
      preview._edit.iFrameStatus = 'default'
      preview._edit.fetchingIframeContent = false
      preview._edit.iframeContent = null
      preview._edit.preview = previewSrc

      return preview
    }
  },
  mounted () {
    EventBus.$on('SHOW_PLAYER_PREVIEW_POPUP', (payload) => {
      this.preview = null
      this.previewOrientation = null

      this.isVisible = true
      this.onCloseCallback = (payload.callback) ? payload.callback : null
      this.previewOrientation = payload.previewOrientation

      // Adjust Preview URL width
      const currentUrl = payload.preview.live || payload.preview.url
      const url = new URL(currentUrl)
      const hasSignature = url.searchParams.get('Signature')

      if (!hasSignature) {
        url.searchParams.set('width', '800')
        url.searchParams.set('zoom', '1')
        url.searchParams.set('use_qsa', '1')

        if (this.$utils.is1280View()) {
          url.searchParams.set('width', '600')
        }

        if (payload.previewOrientation === 'vertical') {
          url.searchParams.set('dir', 'vertical')
        }
      }

      payload.preview.url = url.href
      this.preview = this.filterPreview(payload.preview)

      // Auto Play if video
      this.videoPlayer = null
      if (this.preview.videopreviews) {
        this.$nextTick(_ => {
          window.setTimeout(() => { this.setVideoPreview() }, 5)
        })
      }

      // Adjust Popup Dimension for LED
      const playerPreviewPopUpContentEl = $('#playerPreviewPopUp').find('.content')
      if (payload.ledTag) {
        this.led = true

        const parsedLedTag = this.$utils.parseLedTag(payload.ledTag)

        // Add dimensions in preview
        this.preview = this.filterPreview({
          ...this.preview,
          dimensions: parsedLedTag.dimension
        })

        const calculateAspectRatioFitParams = {
          srcWidth: parsedLedTag.width,
          srcHeight: parsedLedTag.height,
          maxWidth: $('#app').width() - 200,
          maxHeight: $('#app').height() - 200
        }
        const calculateSizeForUI = this.$utils.calculateAspectRatioFit(calculateAspectRatioFitParams)
        $(playerPreviewPopUpContentEl).css({ width: `${calculateSizeForUI.cardWidth}px`, height: `${calculateSizeForUI.cardHeight}px` })
      } else {
        this.led = false
        $(playerPreviewPopUpContentEl).css({ width: '0px', height: '0px' })
      }
    })

    // Listen from Event Bus to hide notification
    EventBus.$on('HIDE_PLAYER_PREVIEW_POPUP', (payload) => {
      this.preview = null
      this.isVisible = false
      this.onCloseCallback = null
    })

    $('#playerPreviewPopUp').on('click', (event) => {
      this.handleCloseIconClick(event)
    })
  }
}
